import Cookies from 'js-cookie'

const TokenKey = 'PUREPAY'

export function getToken() {
  const token = Cookies.get(TokenKey)
  if (token) {
    return JSON.parse(token)
  } else {
    return ''
  }
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
